class SectionRecommended extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.loadSection();
  }

  loadSection = () => {
    axios.get(this.dataset.url)
      .then((response) => {
        const doc = Utils.getDocument(response.data);
        const section = doc.querySelector('section-recommended');
        this.innerHTML = section.innerHTML;
        this.reinitializeCustomElements();
      })
      .catch((error) => {
        Utils.errorHanlder(error);
      })
      .finally(() => {});
  }

  reinitializeCustomElements = () => {
    // Dopo aver inserito il nuovo HTML nel DOM, è necessario aggiornare i web components
    // Altrimenti non riconoscerebbero i nuovi elementi Swiper e i relativi breakpoint
    const breakpoints = this.querySelectorAll('theme-swiper-breakpoint');
    breakpoints.forEach(breakpoint => {
      customElements.upgrade(breakpoint);
    });

    const swipers = this.querySelectorAll('theme-swiper');
    swipers.forEach(swiper => {
      customElements.upgrade(swiper);
      // Richiama init() per inizializzare il Swiper con le nuove configurazioni
      swiper.init();
    });
  }
}
if (!window.customElements.get("section-recommended")) {
  window.customElements.define("section-recommended", SectionRecommended);
}

class ZendeskForm extends ThemeForm {
  fields; zendesk;
  static TICKET_URL = '/api/v2/requests';
  static ATTACHMENT_URL = '/api/v2/uploads';
  static selectors = {
    successTemplate: '[data-success-template]',
    successMessage: '[data-success]',
  }

  constructor () {
    super();
    this.zendesk = this.dataset.zendesk;
    this.successTemplate = this.querySelector(ZendeskForm.selectors.successTemplate);

  }

  getFields = () => {
    // Estrae i dati dal form e li struttura secondo la API Zendesk
    const formData = new FormData(this.form);
    this.fields = {
      request: {
        subject: formData.get('subject'),
        requester: { name: formData.get('name'), email: formData.get('email') },
        comment: {
          body: formData.get('body'),
        }
      }
    };
    // Raccoglie i campi custom (definiti dal backend) e li aggiunge al ticket
    const customFields = [];
    formData.forEach((value, key) => {
      const matches = key.match(/^custom\[(.+)\]$/);
      if (matches) {
        customFields.push({ id: Number(matches[1]), value: value });
      }
    });
    if(customFields.length > 0){
      this.fields.request.custom_fields = customFields;
    }
    // Se ci sono allegati, c'è prima un upload su Zendesk, poi la creazione del ticket
    if(formData.get('attachment').size > 0) {
      this.uploadAttachment(formData.get('attachment'));
    } else {
      this.createTicket();
    }
  }

  uploadAttachment = (field) => {
    // Carica l'allegato su Zendesk (prima di creare il ticket)
    // Zendesk restituisce un token che viene allegato al ticket
    const url = `${this.zendesk}${ZendeskForm.ATTACHMENT_URL}?filename=test.png`;
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: url,
      headers: { 
        'Content-Type': field.type, 
        // Autenticazione Basic con username/token di Zendesk
        "Authorization": `Basic ${btoa(`${this.dataset.username}/token:${this.dataset.token}`)}`
      },
      data : field
    };
    axios.request(config).then((response) => {
      if(response.data.upload.token != undefined){
        // Se l'upload ha successo, aggiunge il token agli uploads del ticket
        this.fields.request.comment.uploads = [response.data.upload.token];
        this.createTicket();
      } else {
        // Se fallisce, mostra un messaggio di errore input-specific
        this.form.attachment.closest('input-text').validateServer(this.dataset.fileError);
      }
    }).catch((error) => {
      this.dispatchEvent(new CustomEvent(Utils.E_FORM_ERROR, { detail: error }));
      this.form.attachment.closest('input-text').validateServer(this.dataset.fileError);
    });
  }

  createTicket = () => {
    this.dispatchEvent(new CustomEvent(Utils.E_FORM_SUBMIT));
    const url = `${this.zendesk}${ZendeskForm.TICKET_URL}`;
    axios.post(url, JSON.stringify(this.fields), {
      headers: {
        'Content-Type': 'application/json',
        "Accept": "application/json",
        "Authorization": `Basic ${btoa(`${this.dataset.username}/token:${this.dataset.token}`)}`
      }
    })
    .then(response => {
      this.success(response.data.request.id);
      this.dispatchEvent(new CustomEvent(Utils.E_FORM_SUCCESS, { detail: response }));
    })
    .catch(error => {
      this.dispatchEvent(new CustomEvent(Utils.E_FORM_ERROR, { detail: error }));
      Utils.errorHanlder(error);
    })
    .finally(() => {
      this.hideLoader();
      this.dispatchEvent(new CustomEvent(Utils.E_FORM_SENT));
      this.form.reset();
    });
  }

  ajaxSubmit = () => {
    this.getFields();
  }

  success = (ticketId) => {
    if(this.successMessage != undefined){
      this.successMessage.remove();
    }
    const template = this.successTemplate.innerHTML.replaceAll('{ticket}', ticketId);
    this.insertAdjacentHTML('afterbegin', template);
    this.successMessage = this.querySelector(ZendeskForm.selectors.successMessage);
  }
}
if (!window.customElements.get("zendesk-form")) {
  window.customElements.define("zendesk-form", ZendeskForm);
}

class VideoPoster extends HTMLElement {
  frame; poster;
  
  constructor() {
    super();
    this.frame = this.querySelector('iframe');
    this.poster = this.querySelector('[data-poster]');
    this.init();
  }

  init = () => {
    if(this.poster != undefined){
      this.poster.addEventListener('click', () => this.playVideo());
    }
  }

  playVideo = () => {
    // Aggiunge il parametro autoplay all'URL dell'iframe
    // Defer il caricamento del video finché l'utente non clicca sul poster
    // Riduce il carico della pagina iniziale
    const url = new URL(this.frame.src);
    url.searchParams.set('autoplay', '1');
    this.frame.src = url.toString();
    this.poster.classList.add('d-none');
  }
}
if (!window.customElements.get("video-poster")) {
  window.customElements.define("video-poster", VideoPoster);
}

class CatalogToggle extends HTMLElement {

  connectedCallback() {
    this.addEventListener('click', this.toggleCatalog.bind(this));
  }

  toggleCatalog = () => {
    const target = this.target;
    if(!target) return;
    // Se il web component catalog-slide non è ancora stato definito, attende che lo sia
    // prima di aperlo. Questo gestisce il caricamento asincrono di componenti
    if(window.customElements.get('catalog-slide') === undefined) {
      window.customElements.whenDefined('catalog-slide').then(() => {
        target.open();
      });
      return;
    }
    target.open();
  }

  get target() {
    const target = document.querySelector(this.dataset.slide);
    if(!target) {
      console.error(`Target ${this.dataset.slide} not found`);
      return;
    }
    if(target.tagName.toLowerCase() !== 'catalog-slide') {
      console.error(`Target ${this.dataset.slide} is not a catalog-slide`);
      return;
    }
    return target;
  }
}
if (!window.customElements.get("catalog-toggle")) {
  window.customElements.define("catalog-toggle", CatalogToggle);
}

class CatalogSlide extends HTMLElement {

  connectedCallback() {
    if(!this.modal) return;

    if(this.isUrlHashTarget) {
      this.open();
    }

    window.addEventListener('hashchange', () => {
      if(this.isUrlHashTarget) {
        this.open();
      }
    });

    this.modal.addEventListener('hidden.bs.modal', () => {
      if(this.isUrlHashTarget) {
        history.replaceState("", document.title, window.location.pathname + window.location.search);
      }
    });
  }

  open = () => {
    if(!this.swiper || !this.modal) return;
    if(window.customElements.get('theme-swiper') === undefined) {
      window.customElements.whenDefined('theme-swiper').then(() => {
        this.open();
      });
      return;
    }
    if(window.customElements.get('bs-modal') === undefined) {
      window.customElements.whenDefined('bs-modal').then(() => {
        this.open();
      });
      return;
    }
    const index = Array.from(this.parentElement.children).indexOf(this);
    this.swiper.swiper.slideTo(index);
    this.modal.show();
  }

  get swiper() {
    const swiper = this.closest('theme-swiper');
    if(!swiper) {
      console.error('Swiper not found');
      return;
    }
    return swiper;
  }

  get modal() {
    const modal = this.closest('bs-modal');
    if(!modal) {
      console.error('Modal not found');
      return;
    }
    return modal;
  }

  get isUrlHashTarget() {
    const url = new URL(window.location);
    return url.hash === `#${this.id}`;
  }
} 
if (!window.customElements.get("catalog-slide")) {
  window.customElements.define("catalog-slide", CatalogSlide);
}